module.exports = __webpack_public_path__ + "img/2(5)-180x180-1.dca56a5b.png";